export enum Languages {
  EN = 'en', // English
  ES = 'es', // Spanish
  ZH = 'zh', // Chinese
  HI = 'hi', // Hindi
  AR = 'ar', // Arabic
  BN = 'bn', // Bengali
  PT = 'pt', // Portuguese
  RU = 'ru', // Russian
  JA = 'ja', // Japanese
  PA = 'pa', // Punjabi
  DE = 'de', // German
  JV = 'jv', // Javanese
  KO = 'ko', // Korean
  FR = 'fr', // French
  TE = 'te', // Telugu
  MR = 'mr', // Marathi
  TR = 'tr', // Turkish
  TA = 'ta', // Tamil
  VI = 'vi', // Vietnamese
  UR = 'ur', // Urdu
  IT = 'it', // Italian
  TH = 'th', // Thai
  GU = 'gu', // Gujarati
  PL = 'pl', // Polish
  UK = 'uk', // Ukrainian
  ML = 'ml', // Malayalam
  KN = 'kn', // Kannada
  FA = 'fa', // Persian
  MY = 'my', // Burmese
  NL = 'nl', // Dutch
  RO = 'ro', // Romanian
  CS = 'cs', // Czech
  HU = 'hu', // Hungarian
  EL = 'el', // Greek
  SV = 'sv', // Swedish
  ID = 'id', // Indonesian
  HE = 'he', // Hebrew
  BG = 'bg', // Bulgarian
  DA = 'da', // Danish
  FI = 'fi', // Finnish
  SK = 'sk', // Slovak
  NO = 'no', // Norwegian
  HR = 'hr', // Croatian
  SR = 'sr', // Serbian
  CA = 'ca', // Catalan
  LT = 'lt', // Lithuanian
  SL = 'sl', // Slovenian
  ET = 'et', // Estonian
  LV = 'lv', // Latvian
  MS = 'ms', // Malay
  IS = 'is', // Icelandic
}
